import { ErrorBoundary } from "react-error-boundary";
import { createBrowserRouter, RouteObject } from "react-router-dom";

import { config } from "config";
import { LocalHomePage } from "pages/LocalHomePage/LocalHomePage";

import { REMOTE_APP_ROUTES } from "./Routes.remotes";
import { LayoutWrapper } from "./components/Layout";
import { ErrorPage } from "./pages/ErrorPage/ErrorPage";
import { MockLayoutPage } from "./pages/MockLayoutPage/MockLayoutPage";
import { StandaloneComponents } from "./pages/StandaloneComponents/StandaloneComponents";
import { isProdEnv } from "./utils/environment";

export const routes: RouteObject[] = [
  {
    path: "",
    element: <LayoutWrapper />,
    errorElement: (
      <ErrorBoundary fallback={<ErrorPage />}>
        <LayoutWrapper>
          <ErrorPage />
        </LayoutWrapper>
      </ErrorBoundary>
    ),
    children: [
      {
        path: "/",
        element: <LocalHomePage />,
      },
      {
        path: config.ROUTES.ERROR,
        element: <ErrorPage logError isServerError />,
      },
      {
        path: config.ROUTES.NOT_FOUND,
        element: <ErrorPage logError />,
      },
      ...REMOTE_APP_ROUTES,
      isProdEnv()
        ? {}
        : {
            path: "layout",
            element: <MockLayoutPage />,
          },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
  ...(isProdEnv()
    ? [{}]
    : [
        {
          path: "/standalone-header-footer",
          element: <StandaloneComponents />,
        },
      ]),
];

export const router = createBrowserRouter(routes);
